import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { FormValidation } from '@core/services/form-validation';

@Component({
  selector: 'app-textarea',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './textarea.html',
  styleUrl: './textarea.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Textarea),
      multi: true,
    },
  ],
})
export class Textarea implements ControlValueAccessor {
  @Input() type: string = 'text';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() formControlName: string = '';
  @Input() control: AbstractControl | null = new FormControl();
  @Input() pattern: string = '';
  @Input() rows: number = 10;
  @Input() cols: number = 30;

  value: any = '';
  disabled = false;

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  constructor(public formValidation: FormValidation) {}

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    this.onChange((event.target as HTMLInputElement).value.trim());
    this.onTouched();
    // const value = (event.target as HTMLInputElement).value;
    // this.value = value;
    // this.onChange(value);
    // this.onTouched();
  }

  // Validation Helpers
  get errorMessage(): string | null {
    if (this.control?.touched && this.control?.invalid) {
      return this.formValidation.getValidationMessage(this.control, this.formControlName);
    }
    return null;
  }

  get isInvalid(): boolean {
    return (this.control?.invalid && this.control?.touched) || false;
  }

  get required(): boolean {
    if (!this.control || !this.control.validator) return false;
    const validator = this.control.validator({} as AbstractControl);
    return !!validator?.['required'];
  }
}
